module.exports = __webpack_public_path__ + "img/assets.d4f0a3e1.svg";